module.exports = __webpack_public_path__ + "static/img/liebao.eda9181b.png";